(function () {
  var STORAGE_KEY = 'peshni_recently_viewed';
  var MAX_STORED = 12;

  function getStored() {
    try {
      var raw = JSON.parse(localStorage.getItem(STORAGE_KEY));
      return Array.isArray(raw) ? raw : [];
    } catch (e) {
      return [];
    }
  }

  function setStored(list) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (e) {
      /* localStorage unavailable (private mode, quota, etc.) — fail silently */
    }
  }

  function trackCurrentProduct() {
    var script = document.querySelector('[data-peshni-rv-current]');
    if (!script) return null;

    var data;
    try {
      data = JSON.parse(script.textContent);
    } catch (e) {
      return null;
    }
    if (!data || !data.handle) return null;

    var list = getStored().filter(function (item) {
      return item && item.handle !== data.handle;
    });

    data.viewedAt = Date.now();
    list.unshift(data);

    if (list.length > MAX_STORED) {
      list = list.slice(0, MAX_STORED);
    }

    setStored(list);

    return data.handle;
  }

  function escapeHtml(value) {
    var div = document.createElement('div');
    div.textContent = value === null || value === undefined ? '' : String(value);
    return div.innerHTML;
  }

  function buildCard(item) {
    var soldOut = item.available === false;
    var priceHtml = '<span class="peshni-rv-card__price-current">' + escapeHtml(item.price) + '</span>';

    if (item.compareAtPrice) {
      priceHtml =
        '<span class="peshni-rv-card__price-compare">' + escapeHtml(item.compareAtPrice) + '</span>' + priceHtml;
    }

    return (
      '<li class="peshni-rv-card' + (soldOut ? ' is-sold-out' : '') + '">' +
      '<a href="' + escapeHtml(item.url) + '" class="peshni-rv-card__link">' +
      '<div class="peshni-rv-card__media">' +
      (item.image
        ? '<img src="' + escapeHtml(item.image) + '" alt="' + escapeHtml(item.title) + '" loading="lazy" width="400" height="400">'
        : '') +
      (soldOut ? '<span class="peshni-rv-card__badge">Sold out</span>' : '') +
      '</div>' +
      '<div class="peshni-rv-card__content">' +
      '<h3 class="peshni-rv-card__title">' + escapeHtml(item.title) + '</h3>' +
      '<div class="peshni-rv-card__price">' + priceHtml + '</div>' +
      '</div>' +
      '</a>' +
      '</li>'
    );
  }

  function renderSections(currentHandle) {
    var sections = document.querySelectorAll('[data-peshni-recently-viewed]');
    if (!sections.length) return;

    var stored = getStored();

    sections.forEach(function (section) {
      var list = section.querySelector('[data-peshni-rv-list]');
      if (!list) return;

      var max = parseInt(section.getAttribute('data-max'), 10) || 6;
      var items = stored
        .filter(function (item) {
          return item && item.handle && item.handle !== currentHandle;
        })
        .slice(0, max);

      if (!items.length) {
        section.hidden = true;
        list.innerHTML = '';
        return;
      }

      list.innerHTML = items.map(buildCard).join('');
      section.hidden = false;
    });
  }

  function init() {
    var currentHandle = trackCurrentProduct();
    renderSections(currentHandle);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
